var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { PDF_DEFAULT_DPI } from "../constants";
import { EventDispatcher } from "../event/EventSystem";
import { clearCanvas, uuidv4 } from "../util";
import CanvasColorConverter from "./CanvasColorConverter";
import { NeoPdfRendererManager } from "./NeoPdfRendererManager";
export var PdfPageEventEnum;
(function (PdfPageEventEnum) {
    PdfPageEventEnum["ON_PAGE_RENDERED"] = "rendered";
})(PdfPageEventEnum || (PdfPageEventEnum = {}));
const MAX_BACKPLANE_BUFFER = 3;
export class NeoPdfPage {
    get pageNo() { return this._pageNo; }
    /**
     * 이 값은 NeoPdfDocument의 load에서 refreshNcodeMappingTable에 의해 자동으로 설정되고
     * MappingStorage가 update될 때마다 자동으로 갱신된다.
     */
    get pageToNcodeMaps() {
        return this._pageToNcodeMaps;
    }
    // addPageToNcodeMaps = (pageMaps: IPageMapItem[]) => {
    //   // this._pageToNcodeMaps 자체가 바뀌는 것을 막자, GridaDoc에서 쓴다.
    //   //
    //   // 이걸, pointer로 복사하게 된다면,
    //   // GridaDoc와 GridaPage의 pageInfo 관련된 항목을 자동 업데이트 되게 수정해야 한다.
    //   const storedMaps = this._pageToNcodeMaps;
    //   pageMaps.forEach(pageMap => {
    //     const isIncluded =
    //       storedMaps.findIndex(storedMap => isSamePage(storedMap.pageInfo, pageMap.pageInfo)) >= 0;
    //     if (!isIncluded) storedMaps.push(pageMap);
    //   });
    // }
    // resetPageToNcodeMaps = () => {
    //   this._pageToNcodeMaps = [];
    // }
    constructor(neoPdf, pageNo) {
        this._loaded = false;
        this._backPlanes = [];
        this._pageToNcodeMaps = [];
        this.dispatcher = new EventDispatcher();
        this.getSize = () => {
            return this._doc.getPageSize(this._pageNo);
        };
        this.initPage = (neoPdf, pageNo) => {
            const self = this;
            return new Promise((resolve, reject) => {
                neoPdf._pdfDoc.getPage(pageNo).then(_pdfPage => {
                    self._pdfPage = _pdfPage;
                    self._loaded = true;
                    self._defaultViewport = _pdfPage.getViewport({ scale: 1, rotation: _pdfPage.rotate });
                    // console.log(`page loaded = ${pageNo}`);
                    resolve(_pdfPage);
                });
            });
        };
        this.getPage = () => __awaiter(this, void 0, void 0, function* () {
            yield this._ready;
            return this._pdfPage;
        });
        this.getViewport = (params) => {
            return this._pdfPage.getViewport(params);
        };
        this.setTranslater = (translater) => {
            this._translater = translater;
        };
        /**
         * 요구되는 dpi에 가장 가까운 이미 렌더링된 이미지를 반환한다
         * @param {number} dpi
         * @return {*}  {IThumbnailDesc}
         */
        this.getNearestThumbnail = (dpi) => {
            if (this._backPlanes) {
                const bps = this._backPlanes.sort((a, b) => Math.abs(dpi - a.dpi) - Math.abs(dpi - b.dpi));
                return bps[0];
            }
            return undefined;
        };
        /**
         * 가장 큰, 이미 렌더링된 이미지를 반환한다
         * @return {*}  {IThumbnailDesc}
         */
        this.getLargestThumbnail = () => {
            if (this._backPlanes) {
                const bps = this._backPlanes.sort((a, b) => b.dpi - a.dpi);
                return bps[0];
            }
            return undefined;
        };
        /**
         * background_image_url_rule를 이용해서 서버에 이미 렌더링된 이미지를 먼저 넣는다
         * 다음과 같은 활용법으로 쓴다
         *
         *
         *     const msi = MappingStorage.getInstance();
         *     const m = msi.getAssociatedPdfPage(pageInfo);
         *     const pdf = await NeoPdfManager.getInstance().getDocument({
         *       url: m.pdf.url, filename: m.pdf.filename, purpose: "pre-rendering"
         *     });
         *
         *     const pageNo = 1;
         *
         *     const mg = msi.getAssociatedPdfPage(pg);
         *     const page = pdf.getPage(pageNo);
         *     const img_url = completeBackgroundImageUrl(
         *       mg.pdf.background_image_url_rule,
         *       { section, owner, book, page: page.pageNo }
         *     );
         *     page.setPreRenderedImage(img_url);
         *
         * @param {string} img_url
         * @memberof NeoPdfPage
         */
        this.setPreRenderedImage = (img_url) => {
            const bgColor = "rgba(255,255,255,1)";
            const vpt = this.viewport;
            const self = this;
            const pageNo = self.pageNo;
            // console.log(`IMAGE LOAD start  ${img_url}`);
            const img = new Image();
            img.onload = function () {
                const canvas = document.createElement("canvas");
                const uuid = uuidv4();
                canvas.id = `scratchCanvas-forImage-${uuid}`;
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                const scale = Math.min(img.width / vpt.width, img.height / vpt.height);
                const dpi = scale * PDF_DEFAULT_DPI;
                const thumbnail = {
                    bgColor,
                    canvas,
                    url: img_url,
                    dst: {
                        x: 0, y: 0, w: img.width, h: img.height
                    },
                    dpi,
                    pdfPage: self
                };
                self._thumbnail = thumbnail;
                self._backPlanes.push(thumbnail);
                self._backPlanes = self._backPlanes.sort((a, b) => b.dpi - a.dpi);
                self._backPlanes = self._backPlanes.slice(0, MAX_BACKPLANE_BUFFER);
                // console.log(`IMAGE LOAD image loaded, dispatch message  ${img_url} ${self.pageNo}/${pageNo}`);
                self.dispatcher.dispatch(PdfPageEventEnum.ON_PAGE_RENDERED, { pdf: self._doc, page: self });
            };
            img.src = img_url;
        };
        this.pdfRenderingTask = undefined;
        /**
         * width, height에 맞는 thumbnail을 반환한다. 백 플레인 캐쉬에도 넣는다
         * 렌더링한 후에는 PdfPageEventEnum.ON_PAGE_RENDERED를 발생시킨다
         *
         * @param {number} width
         * @param {number} height
         * @param {boolean} autoCenter - 정사각형 thumbnail 등, center에 정렬해야 하는 경우
         * @param {(thumbnail: IThumbnailDesc) => void} [callbackFn=undefined]
         * @return {*}  {Promise<IThumbnailDesc>}
         */
        this.generateThumbnail = (width, height, autoCenter = false, topPriority = false, largerOne = false) => __awaiter(this, void 0, void 0, function* () {
            const vpt = this.viewport;
            const scale = Math.min(width / vpt.width, height / vpt.height);
            // if (vpt.width * vpt.height * scale * scale > MAX_PDF_RENDERER_PIXELS) {
            //   scale = Math.sqrt(MAX_PDF_RENDERER_PIXELS / vpt.width / vpt.height);
            // }
            const dpi = Math.round(scale * PDF_DEFAULT_DPI);
            let task;
            let dataUrl = "";
            let renderedWidth = 0;
            let renderedHeight = 0;
            try {
                if (this.pdfRenderingTask) {
                    this.pdfRenderingTask.cancel();
                    this.pdfRenderingTask = undefined;
                }
                task = NeoPdfRendererManager.instance.requestRenderPageAsync({
                    page: this,
                    renderContext: undefined,
                    topPriority: false,
                    dpi,
                    type: "png",
                });
                this.pdfRenderingTask = task;
                const ret = yield task.promise;
                this.pdfRenderingTask = undefined;
                const u8 = ret.png;
                renderedHeight = ret.renderedHeight;
                renderedWidth = ret.renderedWidth;
                let binary = '';
                for (let i = 0, len = u8.length; i < len; i++)
                    binary += String.fromCharCode(u8[i]);
                const b64encoded = btoa(binary);
                dataUrl = "data:image/png;base64," + b64encoded;
            }
            catch (e) {
                console.log(`rendering cancelled: page: ${this.pageNo}`);
                return undefined;
            }
            const ret = {
                bgColor: undefined,
                canvas: undefined,
                url: dataUrl,
                dst: {
                    x: 0, y: 0,
                    w: vpt.width * scale, h: vpt.height * scale
                },
                markPos: undefined,
                dpi,
                pdfPage: this
            };
            return ret;
        });
        /**
         * width, height에 맞는 thumbnail을 반환한다. 백 플레인 캐쉬에도 넣는다
         * 렌더링한 후에는 PdfPageEventEnum.ON_PAGE_RENDERED를 발생시킨다
         *
         * @param {number} width
         * @param {number} height
         * @param {boolean} autoCenter - 정사각형 thumbnail 등, center에 정렬해야 하는 경우
         * @param {(thumbnail: IThumbnailDesc) => void} [callbackFn=undefined]
         * @return {*}  {Promise<IThumbnailDesc>}
         */
        this.generateThumbnail_before20221118 = (width, height, autoCenter = false, topPriority = false, keepOriginalRatio = false) => __awaiter(this, void 0, void 0, function* () {
            const bgColor = "rgba(255,255,255,1)";
            const renderingWorkerKey = `${width}, ${height}`;
            // console.error("20210719 PDF page rendering start")
            const vpt = this.viewport;
            const scale = Math.min(width / vpt.width, height / vpt.height);
            const dpi = Math.round(scale * PDF_DEFAULT_DPI);
            if (this.isSameThumbnail(width, height, bgColor)) {
                return this._thumbnail;
            }
            const bp = this._backPlanes.find(item => item.canvas.width === width && item.canvas.height === height);
            if (bp) {
                return bp;
            }
            // 이전에 있던 큰게 있으면
            const largest = this.getLargestThumbnail();
            if (largest && largest.canvas.width >= width && largest.canvas.height >= height) {
                return largest;
            }
            // 준비 중이면, 이전의 것 중 가장 큰것을
            let desc_promise = null;
            if (this._backPlanes_now_preparing[renderingWorkerKey]) {
                if (largest) {
                    return largest;
                }
                desc_promise = this._backPlanes_now_preparing[renderingWorkerKey];
                const desc = yield desc_promise;
                const prevThumbnail = this._backPlanes.find(t => t.dpi === dpi);
                if (prevThumbnail) {
                    // console.error("20210719 used rendered page")
                    return prevThumbnail;
                }
                // console.error("not has largest and now rendering")
            }
            else {
                // console.log(`IMAGE LOAD rendering START,   ${this.pageNo}  (${width}, ${height})`);
                // 본격적인 준비
                desc_promise = this.render_dpi({ cellIndexOnSheet: 0, dpi, topPriority });
                this._backPlanes_now_preparing[renderingWorkerKey] = desc_promise;
            }
            const desc = yield desc_promise;
            delete this._backPlanes_now_preparing[renderingWorkerKey];
            const canvas = document.createElement("canvas");
            const uuid = uuidv4();
            canvas.id = `scratchCanvas-forImage-${uuid}`;
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            clearCanvas(canvas, ctx, bgColor);
            // const src = { width: vpt.width * scale, height: vpt.height * scale };
            const src = { width: desc.canvas.width, height: desc.canvas.height };
            const dx = autoCenter ? Math.round((width - src.width) / 2) : 0;
            const dy = autoCenter ? Math.round((height - src.height) / 2) : 0;
            ctx.drawImage(desc.canvas, 0, 0, src.width, src.height, dx, dy, src.width, src.height);
            const thumbnail = {
                bgColor,
                canvas,
                url: canvas.toDataURL(),
                dst: {
                    x: dx, y: dy, w: src.width, h: src.height
                },
                dpi,
                pdfPage: this
            };
            this._backPlanes.push(thumbnail);
            this._backPlanes = this._backPlanes.sort((a, b) => b.dpi - a.dpi);
            this._backPlanes = this._backPlanes.slice(0, MAX_BACKPLANE_BUFFER);
            this._thumbnail = thumbnail;
            // console.log(`IMAGE LOAD rendering completed, dispatch message  ${this.pageNo}  (${width}, ${height})`);
            // console.error("20210719 PDF page rendered")
            /// this.dispatchPageRendered();
            return thumbnail;
        });
        this.dispatchPageRendered = () => {
            this.dispatcher.dispatch(PdfPageEventEnum.ON_PAGE_RENDERED, { pdf: this._doc, page: this });
        };
        this.isSameThumbnail = (width, height, bgColor) => {
            if (!this._thumbnail)
                return false;
            const i = this._thumbnail.canvas;
            if (i.width === width && i.height === height && bgColor === this._thumbnail.bgColor) {
                return true;
            }
            return false;
        };
        // public getThumbnailUrl = async (width: number, height: number, bgColor = "rgba(255,255,255,0)", drawCalibrationMark = false, markPos = 0) => {
        //   // console.log(`getThumbnailUrl called`);
        //   const thumbnail = await this.generateThumbnail(width, height, true);
        //   const canvas = document.createElement("canvas");
        //   const uuid = uuidv4();
        //   canvas.id = `scratchCanvas-forImage-${uuid}`;
        //   canvas.width = thumbnail.canvas.width;
        //   canvas.height = thumbnail.canvas.height;
        //   const ctx = canvas.getContext('2d');
        //   ctx.drawImage(thumbnail.canvas, 0, 0);
        //   let markDrawn = { x: undefined, y: undefined };
        //   if (drawCalibrationMark) {
        //     const dx = thumbnail.dst.x;
        //     const dy = thumbnail.dst.y;
        //     const dw = thumbnail.dst.w;
        //     const dh = thumbnail.dst.h;
        //     markDrawn = drawCrossMark({ ctx, drawMarkRatio: 0.1, markPos, x: dx, y: dy, w: dw, h: dh });
        //   }
        //   const dataURL = canvas.toDataURL();
        //   const retVal: IThumbnailDesc = { ...thumbnail, url: dataURL, markPos: { ...markDrawn } };
        //   return retVal;
        // }
        this.render_dpi = (arg) => __awaiter(this, void 0, void 0, function* () {
            const { topPriority } = arg || {};
            const cellIndexOnSheet = (arg === null || arg === void 0 ? void 0 : arg.cellIndexOnSheet) ? arg.cellIndexOnSheet : 0;
            let dpi = (arg === null || arg === void 0 ? void 0 : arg.dpi) ? arg.dpi : 72;
            const page = this._pdfPage;
            const viewport = this.viewport;
            const rotation = viewport.rotation;
            let canvas = null;
            if (!arg.doNotProduceImage) {
                const ret = yield NeoPdfRendererManager.instance.requestRenderPageAsync({ page: this, renderContext: undefined, topPriority, dpi }).promise;
                canvas = ret.canvas;
                dpi = ret.renderedDpi;
            }
            if (!canvas) {
                const doc = this._doc;
                const result = {
                    pdfPageInfo: {
                        url: doc.url,
                        filename: doc.filename,
                        fingerprint: doc.fingerprint,
                        id: undefined,
                        numPages: doc.numPages,
                        pageNo: this._pageNo,
                        // 2021/04/18 kitty
                        size_pu: { width: viewport.width, height: viewport.height }
                    },
                    cellIndexOnSheet,
                    canvas: undefined,
                    rotation,
                    width_pu: viewport.width,
                    height_pu: viewport.height,
                    drawnRect: {
                        unit: "600dpi",
                        x: 0, y: 0, width: 0, height: 0,
                    }
                };
                return result;
            }
            const doc = this._doc;
            const result = {
                pdfPageInfo: {
                    url: doc.url,
                    filename: doc.filename,
                    fingerprint: doc.fingerprint,
                    id: undefined,
                    numPages: doc.numPages,
                    pageNo: this._pageNo,
                    // 2021/04/18 kitty
                    size_pu: { width: viewport.width, height: viewport.height }
                },
                cellIndexOnSheet,
                canvas,
                rotation,
                width_pu: viewport.width,
                height_pu: viewport.height,
                drawnRect: {
                    unit: "600dpi",
                    x: 0, y: 0, width: 0, height: 0,
                }
            };
            return result;
        });
        /**
         *
         * @param index - splitted area index, starting from 0
         * @param dpi - print dpi
         */
        this.render_dpi_before_20221120 = (arg) => __awaiter(this, void 0, void 0, function* () {
            const { topPriority } = arg || {};
            const cellIndexOnSheet = (arg === null || arg === void 0 ? void 0 : arg.cellIndexOnSheet) ? arg.cellIndexOnSheet : 0;
            let dpi = (arg === null || arg === void 0 ? void 0 : arg.dpi) ? arg.dpi : 72;
            const page = this._pdfPage;
            const viewport = this.viewport;
            const rotation = viewport.rotation;
            let success = false;
            let cnt = 3;
            let canvas = null;
            let ctx = null;
            while (!success && cnt > 0) {
                try {
                    // console.error(this.pageNo, "rendering", dpi)
                    if (!arg.doNotProduceImage) {
                        const pageNo = this._pageNo;
                        canvas = document.createElement("canvas");
                        const uuid = uuidv4();
                        canvas.id = `scratchCanvas-${pageNo}-${uuid}`;
                        ctx = canvas.getContext('2d');
                        const PRINT_RESOLUTION = dpi;
                        const scale = PRINT_RESOLUTION / PDF_DEFAULT_DPI;
                        // const CSS_UNITS = 96.0 / PDF_DEFAULT_DPI;
                        canvas.width = Math.floor(viewport.width * scale);
                        canvas.height = Math.floor(viewport.height * scale);
                        clearCanvas(canvas, ctx);
                        // const cssWidth = Math.floor(viewport.width * CSS_UNITS);
                        // const cssHeight = Math.floor(viewport.height * CSS_UNITS);
                        // ctx.save();
                        // ctx.fillStyle = "rgb(255, 255, 255)";
                        // ctx.fillRect(0, 0, canvas.width, canvas.height);
                        // ctx.restore();
                        const renderContext = {
                            canvas,
                            canvasContext: ctx,
                            transform: [scale, 0, 0, scale, 0, 0],
                            viewport: page.getViewport({
                                scale: 1,
                                rotation: viewport.rotation
                            }),
                            // intent: "print"
                        };
                        // 2022/08/01
                        yield page.render(renderContext).promise;
                        // await NeoPdfRendererManager.instance.requestRenderPageAsync({ page: this, renderContext, topPriority, dpi }).promise;
                        success = true;
                    }
                }
                catch (e) {
                    console.error(`PdfJs Renderer: retry to draw page ${this.pageNo}, count: ${cnt}`);
                    ctx = null;
                    canvas = null;
                    dpi = Math.round(dpi * 0.8);
                    cnt--;
                }
            }
            if (!canvas) {
                const doc = this._doc;
                const result = {
                    pdfPageInfo: {
                        url: doc.url,
                        filename: doc.filename,
                        fingerprint: doc.fingerprint,
                        id: undefined,
                        numPages: doc.numPages,
                        pageNo: this._pageNo,
                        // 2021/04/18 kitty
                        size_pu: { width: viewport.width, height: viewport.height }
                    },
                    cellIndexOnSheet,
                    canvas: undefined,
                    rotation,
                    width_pu: viewport.width,
                    height_pu: viewport.height,
                    drawnRect: {
                        unit: "600dpi",
                        x: 0, y: 0, width: 0, height: 0,
                    }
                };
                return result;
            }
            const doc = this._doc;
            const result = {
                pdfPageInfo: {
                    url: doc.url,
                    filename: doc.filename,
                    fingerprint: doc.fingerprint,
                    id: undefined,
                    numPages: doc.numPages,
                    pageNo: this._pageNo,
                    // 2021/04/18 kitty
                    size_pu: { width: viewport.width, height: viewport.height }
                },
                cellIndexOnSheet,
                canvas,
                rotation,
                width_pu: viewport.width,
                height_pu: viewport.height,
                drawnRect: {
                    unit: "600dpi",
                    x: 0, y: 0, width: 0, height: 0,
                }
            };
            return result;
        });
        this.convertColor = (canvasDesc, colorConvertMode, luminanceMaxRatio) => __awaiter(this, void 0, void 0, function* () {
            if (colorConvertMode) {
                const pdfCanvas = canvasDesc.canvas;
                const converter = new CanvasColorConverter(pdfCanvas);
                yield converter.convert(colorConvertMode, luminanceMaxRatio);
            }
            return canvasDesc;
        });
        this.addEventListener = (eventName, listener) => {
            this.dispatcher.on(eventName, listener, undefined);
            // console.log("bound", listener);
        };
        /**
         *
         * @param eventName
         * @param listener
         */
        this.removeEventListener = (eventName, listener) => {
            this.dispatcher.off(eventName, listener);
        };
        this._pageNo = pageNo;
        this._doc = neoPdf;
        this._pdfPage = null;
        this._defaultViewport = null;
        this._ready = this.initPage(neoPdf, pageNo);
        // this._ready.then(_pdfPage => {
        //   this.generateThumbnail(this._defaultViewport.width / 4, this._defaultViewport.height / 4)
        //     .then(thumbnail => {
        //       this._thumbnail = thumbnail;
        //       console.log(`thumbnail generated = ${pageNo}`);
        //     });
        // })
        this._backPlanes_now_preparing = {};
    }
    // render = (params: RenderParameters) => {
    //   // await this._ready;
    //   // const renderTask: PdfJs.PDFRenderTask = this._pdfPage.render(params);
    //   // const ret = await renderTask.promise;
    //   // return ret;
    //   const renderTask: PdfJsType.RenderTask = this._pdfPage.render(params);
    //   return renderTask;
    // }
    get viewport() {
        return this._defaultViewport;
    }
}
/**
 * 더미 렌더링 이미지를 반환한다
 * @return {*}  {IThumbnailDesc}
 */
NeoPdfPage.getDummyThumbnail = () => {
    const thumbnail = {
        // imageData: undefined,
        bgColor: "",
        canvas: { width: 0, height: 0 },
        url: "//:0",
        dst: {
            x: 0, y: 0, w: 0, h: 0
        },
        dpi: 72,
        pdfPage: undefined,
    };
    return thumbnail;
};
//# sourceMappingURL=NeoPdfPage.js.map